export default {"src":"/_next/static/media/bed.4ae47871.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};